import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	title: {
		id: 'software-deployment-frequency-report.header.title',
		defaultMessage: 'Deployment frequency',
		description:
			'The title of the report. Deployment frequency in software measures how often a team deploys code to production.',
	},
	description: {
		id: 'software-deployment-frequency-report.header.description',
		defaultMessage:
			'Understand your project’s deployment frequency to see how often you are shipping value to your customers. Using data from your deployment provider, correlate your batch size to how often your team deploys.',
		description:
			'Text providing a quick overview of the purpose of the deployment frequency report page',
	},
	learnMore: {
		id: 'software-deployment-frequency-report.header.learn-more',
		defaultMessage: 'Learn more',
		description: 'Learn more link taking you to a page with more information',
	},
});
